import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { BrandBanner } from '../components/BrandBanner';
import { BookOnlineSection } from '../components/BookOnlineSection';
import { ServicesSection } from '../components/ServicesSection';
import { RevolutionSection } from '../components/RevolutionSection';
import { FAQSection } from '../components/FAQSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
export function Home() {
  return <main data-id="element-683">
      <HeroSection data-id="element-684" />
      <BrandBanner data-id="element-685" />
      <BookOnlineSection data-id="element-686" />
      <ServicesSection data-id="element-687" />
      <RevolutionSection data-id="element-688" />
      <FAQSection data-id="element-689" />
      <WhyChooseUsSection data-id="element-690" />
    </main>;
}